import styled from "styled-components";
import { useNavigate } from "react-router-dom";

export default function TransparentCard(props) {
  const navigate = useNavigate();
  const option = props.option;

  return (
    <TransparentStyltedCard
      onClick={(e) => {
        navigate(option.link);
      }}
    >
      <div className={"content-container"}>
        <div className={"image-container"}>
          <img
            src={option.image}
            alt="showcase"
            style={{
              width: "100%",
              aspectRatio: "5/4",
              objectFit: "cover",
            }}
          />
        </div>
      </div>
      <CardTitle className={"content-container"} isMobile={props.isMobile}>
        {option.title}
      </CardTitle>
    </TransparentStyltedCard>
  );
}

const TransparentStyltedCard = styled.div`
  width: 100%;
  height: auto;
  background-color: transparent;
  border-color: transparent;
  color: white;
  padding: 0;
  cursor: pointer;

  img {
    transition: all 0.5s ease-out;
  }
  .content-container {
    overflow: hidden;
    border-radius: 10px;
    transition: filter 0.5s ease-out;
    text-align: center;
  }
  .image-container {
    position: relative;
    overflow: hidden;
    border-radius: 10px;
  }

  &:hover {
    .content-container {
      z-index: 2;
      filter: drop-shadow(0 0 10px #00dbf8);
    }
    img {
      transform: scale(1.05);
    }

    background-color: transparent !important;
    color: white !important;
  }
`;

const CardTitle = styled.div`
  position: relative;

  width: 100%;
  padding-top: 1%;
  color: white;
  font-weight: 400;
  line-height: ${(props) => (props.isMobile ? "1.2" : "1.5")};
  font-size: calc(
    100vh * ${(props) => (props.isMobile ? 16 : 32)} /
      ${(props) => (props.isMobile ? 720 : 1080)}
  );
  white-space: normal;
`;
